import { render, staticRenderFns } from "./ClientProjectsEditDetailsStep7.vue?vue&type=template&id=7f068f53&"
import script from "./ClientProjectsEditDetailsStep7.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetailsStep7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports